module.exports = __webpack_public_path__ + "img/Lately.96208f32.jpeg";